export default "__VITE_ASSET__CyZx$8_h__"